<template>
    <div class="tx-center">
        <div v-if="loading" :class="(classes) ? classes : 'spinner-border spinner-border-xl'" role="status">
            <span class="sr-only">{{ message ? message : 'Loading...' }}</span>
        </div>
		<div v-else> 
			<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
			<span class="ml-1">{{ message ? message : 'Please wait...' }}</span>
		</div>
    </div>
</template>

<style scoped>
	.spinner-border {
		color: #1c273c;
	}
</style>

<script>
	export default {
		props: ['loading', 'classes', 'message'],
	};
</script>
